import React, { Component } from 'react';
import styled from 'styled-components';
import { connect } from 'react-redux';

import api from 'api';

import css from 'css';

import {isValidEmail, msg, gtmPush, cookie, isValidPersonalNumber} from 'helpers';

import { Input } from 'partials/formElements';
import CheckmarkCircle from 'images/CheckmarkCircle';

import {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback,
    setCheckoutCustomer,
    setCheckoutCustomerId,
    setCheckoutOpportunityCustomerId,
    setCheckoutError,
} from 'store';

const Wrapper = styled.section``

const InputRow = styled.div`
    display: flex;
    width: 100%;
    margin-bottom: 30px;
    align-items: center;

    .input-wrapper {
        width: 100%;

        input {
            width: 100%;
            height: auto;
            padding: 15px;
            background: #E3EFFD;
            border: none;
            border-bottom: 4px solid ${css.colors.blue};
        }

        label {
            color: #FFF;
        }

        &.error {
            input {
                border-color: ${css.colors.red};
            }
        }
    }

    svg {
        position: absolute;
        top: 40px;
        right: 15px;
        opacity: 0;
    }

    &.valid {
        .input-wrapper input {
            padding-right: 50px;
        }

        svg {
            opacity: 1;
        }
    }
`

class Contact extends Component {
    constructor(props) {
        super(props);

        this.state = {
            errors: {
                firstName: '',
                lastName: '',
                phone: '',
                email: '',
                personalNumber: '',
            },
            isValid: {
                firstName: false,
                lastName: false,
                phone: false,
                email: false,
                personalNumber: false,
            },
        }
        this._getCookies();
    }

    componentDidMount() {
        this.props.setCheckoutTitle('Dine kontaktdetaljer');
        this.props.setCheckoutSubtitle('');
        this.props.setCheckoutNextCallback(this._onSubmit.bind(this));
        gtmPush({
            'event': 'virtual_pageview',
            'pageTitle': 'Checkout - Kontaktdetaljer',
            'pageURI': '/checkout/kontaktdetaljer', 
        });
        if (cookie.get('shoppingCartUserData')) {
            const shoppingCartUserData = JSON.parse(cookie.get('shoppingCartUserData'));
            this.props.customer.email = shoppingCartUserData.email;
            this.props.customer.firstName = shoppingCartUserData.firstName;
            this.props.customer.lastName = shoppingCartUserData.lastName;
            this.props.customer.phone = shoppingCartUserData.phone;
            this.props.customer.personalNumber = shoppingCartUserData.personalNumber;
        }
    }

    _onInputChange(key, value) {
        this.setState({
            errors: { ...this.state.errors, [key]: '' }
        });

        if (key === 'phone') {
            value = value.toString()
                .replace(/\s\s/g, ' ')
                .replace(/\+\+/g, '+')
                .replace(/--/g, '-')
                .replace(/[^\d\s()+-]/g, '')
        }

        if (key === 'postCode') {
            value = value.toString()
                .replace(/[^\d]/g, '')
                .substring(0, 4);
        }

        if (key === 'personalNumber') {
            value = value.toString()
                .replace(/(\d{6})/g, '$1 ')
                .replace(/\s\s/g, ' ')
                .replace(/[^\d\s]/g, '')
                .replace(/(^\s+|\s+$)/, '')
                .substring(0, 12);
        }

        this.props.setCheckoutCustomer({ ...this.props.customer, [key]: value });
    }

    _validateInput(key) {
        const value = this.props.customer[key];

        if (!value) {
            this.setState(state => ({
                errors: { ...state.errors, [key]: msg('fieldRequired') },
                isValid: { ...state.isValid, [key]: false }
            }));

            return false;
        }

        if (key === 'email' && !isValidEmail(value)) {
            this.setState(state => ({
                errors: { ...state.errors, [key]: msg('invalidEmail') },
                isValid: { ...state.isValid, [key]: false }
            }));

            return false;
        }

        if (key === 'phone' && value.toString().replace(/\D/g, '').length < 8) {
            this.setState(state => ({
                errors: { ...state.errors, [key]: msg('invalidPhoneNumber') },
                isValid: { ...state.isValid, [key]: false }
            }));

            return false;
        }

        if (key === 'personalNumber') {
            if (!isValidPersonalNumber(value.toString().replace(/\D/g, ''))) {
                this.setState(state => ({
                    errors: { ...state.errors, [key]: msg('invalidSIDNumber') },
                    isValid: { ...state.isValid, [key]: false }
                }));
                return false;
            }
        }

        this.setState(state => ({
            errors: { ...state.errors, [key]: '' },
            isValid: { ...state.isValid, [key]: true }
        }));

        return true;
    }

    _onSubmit = () => {
        const isValid = !Object.keys(this.state.isValid).filter(key => {
            return !this._validateInput(key);
        }).length;

        if (!isValid) {
            return false;
        }

        this._addCookie();

        if (this.props.customer.id) {
            return this._onCustomerUpdate().then(response => {
                return true;
            }).catch(error => {
                this.props.setCheckoutError(msg('unableToRegister'))

                return false;
            });
        }

        return this._onCustomerCreation().then(response => {
            return true;
        }).catch(error => {
            this.props.setCheckoutError(msg('unableToRegister'))

            return false;
        });
    }

    _getCookies() {
        if (!cookie.get('shoppingCartUserData')) {
            cookie.set('shoppingCartUserData', JSON.stringify([]), 1);
        }
        let costumer = JSON.parse(cookie.get('shoppingCartUserData'));
        this.props.customer.email = costumer.email;
        this.props.customer.firstName = costumer.firstName;
        this.props.customer.lastName = costumer.lastName;
        this.props.customer.phone = costumer.phone;
        this.props.customer.personalNumber = costumer.personalNumber;
    }

    _addCookie() {
        cookie.set('shoppingCartUserData', JSON.stringify(this.props.customer), 1);
    }

    _onCustomerCreation() {
        const { customer } = this.props;

        const parameters = {
            firstName: customer.firstName ? customer.firstName.trim() : null,
            lastName: customer.lastName ? customer.lastName.trim() : null,
            personalNumber: customer.personalNumber ? customer.personalNumber.trim() : null,
            email: customer.email ? customer.email.trim() : null,
            phone: customer.phone ? customer.phone.trim() : null,
            country: null,
            city: null,
            street: null,
            postalCode: null,
            partialObject: customer.partialObject,
        }

        return api.createCustomer(parameters).then(response => {
            this.props.setCheckoutCustomerId(response.data.customerId);
            this.props.setCheckoutOpportunityCustomerId(response.data.customerId);
        });
    }

    _onCustomerUpdate() {
        const { customer } = this.props;

        const parameters = {
            firstName: customer.firstName ? customer.firstName.trim() : null,
            lastName: customer.lastName ? customer.lastName.trim() : null,
            personalNumber: customer.personalNumber ? customer.personalNumber.trim() : null,
            email: customer.email ? customer.email.trim() : null,
            phone: customer.phone ? customer.phone.trim() : null,
            country: null,
            city: null,
            street: null,
            postalCode: null,
            partialObject: customer.partialObject,
        }

        return api.updateCustomer(customer.id, parameters);
    }

    render() {
        const { errors, isValid } = this.state;
        const { firstName, lastName, phone, email, personalNumber } = this.props.customer;

        return (
            <Wrapper>
                <InputRow className={isValid.firstName ? 'valid' : ''}>
                    <Input label="Fornavn" value={firstName || ''} error={errors.firstName} onChange={e => this._onInputChange('firstName', e.target.value)} onBlur={() => this._validateInput('firstName')} />
                    <CheckmarkCircle />
                </InputRow>
                <InputRow className={isValid.lastName ? 'valid' : ''}>
                    <Input label="Etternavn" value={lastName || ''} error={errors.lastName} onChange={e => this._onInputChange('lastName', e.target.value)} onBlur={() => this._validateInput('lastName')} />
                    <CheckmarkCircle />
                </InputRow>
                <InputRow className={isValid.personalNumber ? 'valid' : ''}>
                    <Input
                        label="Elevens personnummer"
                        value={personalNumber || ''}
                        error={errors.personalNumber}
                        onChange={e => this._onInputChange('personalNumber', e.target.value)}
                        onBlur={() => this._validateInput('personalNumber')}
                        tooltipTitle='Hvorfor trenger vi dette?'
                        tooltipContent='Vi ber om ditt fødselsnummer for å kunne tilby deg kjøp med faktura og delbetaling. Ditt fødselsnummer blir brukt til å foreta en kredittsjekk. Har du ikke et norsk personnummer? <a href="/gratis-radgivning"> Ta kontakt med oss </a>'
                    />
                    <CheckmarkCircle />
                </InputRow>
                <InputRow className={isValid.phone ? 'valid' : ''}>
                    <Input label="Telefonnummer" value={phone || ''} error={errors.phone} onChange={e => this._onInputChange('phone', e.target.value)} onBlur={() => this._validateInput('phone')} />
                    <CheckmarkCircle />
                </InputRow>
                <InputRow className={isValid.email ? 'valid' : ''}>
                    <Input label="E-post" value={email || ''} error={errors.email} onChange={e => this._onInputChange('email', e.target.value)} onBlur={() => this._validateInput('email')} />
                    <CheckmarkCircle />
                </InputRow>
            </Wrapper>
        );
    }
}

const mapStateToProps = state => ({
    customer: state.customer,
});

const actions = {
    setCheckoutTitle,
    setCheckoutSubtitle,
    setCheckoutNextCallback,
    setCheckoutCustomer,
    setCheckoutCustomerId,
    setCheckoutOpportunityCustomerId,
    setCheckoutError,
}

export default connect(mapStateToProps, actions)(Contact);


// WEBPACK FOOTER //
// ./src/partials/Checkout/Contact.js